var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "41px",
    viewBox: "0 0 41 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10 Copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AFIX-desktop__mk2",
    transform: "translate(-466.000000, -3995.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3",
    transform: "translate(0.000000, 3662.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(449.000000, 316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-4",
    transform: "translate(17.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 20.5,
    cy: 20.5,
    r: 20.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "phone-icon-Bg--black.6c4cca6b2ab33213e00f5b6b19003587-Copy-4",
    transform: "translate(9.000000, 9.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone-icon--brown.d2dce4622ad01ee382edab80cef20a4e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.191385,23.949608 C15.4677077,23.7117058 13.8292117,23.083825 12.4135153,22.1187018 C10.7729245,21.031649 9.26587452,19.772759 7.9207034,18.3657034 C6.26837784,16.6859728 4.58578066,15.0278386 3.12769796,13.1753357 C1.9798993,11.6875742 0.953187088,10.1278243 0.393162244,8.33531176 C0.0037228606,7.1956449 -0.098250302,5.98478494 0.0954913808,4.80067852 C0.347754824,3.38730514 1.13481677,2.23788944 2.21198166,1.27564373 C2.65624568,0.897713868 3.1387384,0.562533954 3.65240594,0.275004176 C4.2774287,-0.102694409 5.07876872,-0.0904302972 5.69069456,0.306199174 C7.12494382,1.11807776 8.22423572,2.37205144 8.80614808,3.86002934 C9.0093425,4.28697594 8.9523203,4.78526182 8.65731264,5.1606208 C8.29657592,5.62374654 7.9207034,6.0748742 7.55744404,6.53799994 C7.23706946,6.94833414 6.90408172,7.3514695 6.61902402,7.78340024 C6.31806176,8.18702152 6.3231465,8.7287397 6.6316372,9.12718478 C7.350588,10.0870309 8.04683512,11.0756723 8.82885178,11.9899257 C10.2438158,13.6560684 11.8105602,15.2002087 13.5108613,16.6043858 C13.8892565,16.9139362 14.2954006,17.1874923 14.6990221,17.4682473 C15.0501085,17.727865 15.5280289,17.7691083 15.9224998,17.5738305 C16.3550263,17.3710466 16.7760464,17.1467729 17.1838171,16.9019381 C17.7488872,16.5587932 18.3038668,16.2060497 18.8588464,15.867704 C19.3253181,15.5837369 19.9198017,15.5726125 20.3976534,15.8389086 C21.8288896,16.5144074 22.9956348,17.607439 23.7275308,18.9584085 C24.1488042,19.6492044 24.0764732,20.5159386 23.545901,21.1348594 C22.1508842,22.87698 20.3673816,23.9520078 17.9961053,24 C17.7271368,23.996278 17.4585451,23.9794586 17.191385,23.949608 Z",
    id: "Path"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhite);
export default __webpack_public_path__ + "static/media/phone--white.964c9f8f57008dbf373e6fe9f1c2d474.svg";
export { ForwardRef as ReactComponent };